/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Register_DescriptionInputs */

const en_auth_register_description = /** @type {(inputs: Auth_Register_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an account to get started`)
};

const es_auth_register_description = /** @type {(inputs: Auth_Register_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una cuenta para empezar`)
};

/**
* | output |
* | --- |
* | "Create an account to get started" |
*
* @param {Auth_Register_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_register_description = /** @type {((inputs?: Auth_Register_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Register_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_register_description(inputs)
	return es_auth_register_description(inputs)
});